import { clsx } from "clsx";

export function Tabs<T extends string>({ value, tabs, onChange }: { value: T; tabs: { value: T; label: string }[]; onChange: (value: T) => void }) {
  return (
    <div className="flex rounded-md bg-hover p-1 dark:bg-hover-dark">
      {tabs.map((tab) => (
        <button
          key={tab.value}
          className={clsx("h-8 flex-1 rounded px-3 text-xs font-medium transition", value === tab.value ? "bg-card text-text shadow-sm dark:bg-card-dark dark:text-text-dark" : "text-muted hover:text-text dark:text-muted-dark")}
          onClick={() => onChange(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
